module.exports = __webpack_public_path__ + "img/hat_11.43b44c31.png";